module.exports = __webpack_public_path__ + "static/GminaMalechowo-00011e41f7257d13db7a1f68b9accfd8.svg";